
import { LogManager } from "@mcleod/core";
import { AutogenLayoutEscrowTransaction } from "./autogen/AutogenLayoutEscrowTransaction";
import { DataSourceMode, DataSourceModeChangeEvent, DataSourceExecutionEvent, DataSourceAction } from "@mcleod/components";

const log = LogManager.getLogger("lme.settlement.EscrowTransaction");

export class EscrowTransaction extends AutogenLayoutEscrowTransaction {
    

    /** This is an event handler for the afterModeChange event of sourceEscrowTransaction. */
    sourceEscrowTransactionAfterModeChange(event: DataSourceModeChangeEvent) {
        this.tabsetEscrow.visible = event.newMode !== DataSourceMode.ADD;
        this.layoutEscrowTransactionFieldsAdd.visible = event.newMode === DataSourceMode.ADD;
    }

    /** This is an event handler for the afterExecution event of sourceEscrowTransaction. */
    sourceEscrowTransactionAfterExecution(event: DataSourceExecutionEvent) {
        if (event.getAction() === DataSourceAction.SEARCH) {
            const canEdit = this.activeRow.getBoolean("can_edit", false);
            if (!canEdit) {
                this.titleEditModeSuffix = " ";
            }
        }
    }
}
